import './polyfill.js'
import './common.js'
import './campus-tour-2021.js'
